import React, { useState } from "react";
import { InfoIcon, Tooltip } from "./style";

interface IProps {
  message: string;
}

const TooltipComp: React.FC<IProps> = ({ message }: IProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}>
      <InfoIcon>?</InfoIcon>

      {showTooltip && (
        <Tooltip>
          <p>{message}</p>
        </Tooltip>
      )}
    </div>
  );
};

export default TooltipComp;
